module.exports = __webpack_public_path__ + "static/media/logo.1b686293.svg";